import { useEffect } from "react"
import { beep } from "./beep.js"

const ErrorPopup = ({ message, onClose }) => {
	useEffect(() => {
		if (message) beep()
	}, [message])

	if (!message) return null
	const text = Array.isArray(message)
		? message.map((d) => d?.msg ?? String(d)).join("; ")
		: typeof message === "object"
		? JSON.stringify(message)
		: String(message)
	return (
		<div className="error-popup">
			<span className="error-popup-msg">{text}</span>
			<button className="error-popup-close" onClick={onClose}>&#x2715;</button>
		</div>
	)
}

export default ErrorPopup
